import { Stack, Switch, Tooltip, Typography } from '@mui/material';
import { Controller, type Control, type FieldValues } from 'react-hook-form';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons';
import { InfoIconStyled } from './styles';
import { fields, rotationTexts } from '../constants';

export const ManageHeader = ({
  control,
  isDisplay,
}: {
  control: Control<FieldValues>;
  isDisplay: boolean;
}) => {
  return (
    <Stack direction="row" alignItems="center">
      <Stack flex={1}>
        <Typography variant="h3" data-testid="manage-creative-screen-header">
          Step 2: Manage Creative
        </Typography>
      </Stack>
      {!isDisplay && (
        <Stack direction="row" alignItems="center" justifyContent="flex-end">
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Even Rotation</Typography>
            <Tooltip title={rotationTexts.random}>
              <InfoIconStyled icon={faInfoCircle} />
            </Tooltip>
          </Stack>
          <Controller
            control={control}
            name={fields.weightingRotation.path}
            render={({ field }) => (
              <Switch
                {...field}
                checked={field.value}
                onChange={e => {
                  field.onChange(e.target.checked);
                }}
              />
            )}
          />
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography variant="body2">Weighted Rotation</Typography>
            <Tooltip title={rotationTexts.weighted}>
              <InfoIconStyled icon={faInfoCircle} />
            </Tooltip>
          </Stack>
        </Stack>
      )}
    </Stack>
  );
};
